const brands = {
  localhost: {
    key: "localhost",
    name: "LocalDev",
    adminTitle: "LocalDev Admin",
    pageTitle: "Agent LocalDev",
    footerText: "localhost",
    footerUrl: "#",
    faviconUrl: null,
    logoUrl: null,
    logoFullUrl: null,
    get logo() {
      return this.logoUrl || require("@/assets/images/brands/localhost/logo.png");
    },
    get logoFull() {
      return this.logoFullUrl || require("@/assets/images/brands/localhost/logo-full.png");
    },
    get favicon() {
      return this.faviconUrl || require("@/assets/images/brands/localhost/favicon.ico");
    },
  },
  habocruise: {
    key: "habocruise",
    name: "HaboCruise",
    adminTitle: "HaboCruise Admin",
    pageTitle: "Agent HaboCruise",
    footerText: "Habocruise.com",
    footerUrl: "https://agent.habocruise.com",
    faviconUrl: null,
    logoUrl: null,
    logoFullUrl: null,
    get logo() {
      return this.logoUrl || require("@/assets/images/brands/habocruise/logo.png");
    },
    get logoFull() {
      return this.logoFullUrl || require("@/assets/images/brands/habocruise/logo-full.png");
    },
    get favicon() {
      return this.faviconUrl || require("@/assets/images/brands/habocruise/favicon.ico");
    },
  },
  promptcruise: {
    key: "promptcruise",
    name: "PromptCruise",
    adminTitle: "Promptcruise Admin",
    pageTitle: "Agent PromptCruise",
    footerText: "Promptcruise.com",
    footerUrl: "https://agent.promptcruise.com",
    faviconUrl: null,
    logoUrl: null,
    logoFullUrl: null,
    get logo() {
      return this.logoUrl || require("@/assets/images/brands/promptcruise/logo.png");
    },
    get logoFull() {
      return this.logoFullUrl || require("@/assets/images/brands/promptcruise/logo-full.png");
    },
    get favicon() {
      return this.faviconUrl || require("@/assets/images/brands/promptcruise/favicon.ico");
    },
  },
};

const DEFAULT_BRAND = "promptcruise";

const domainPatterns = [
  { pattern: /^localhost$/, brand: "localhost" },
  { pattern: /habocruise/, brand: "habocruise" },
  { pattern: /promptcruise/, brand: "promptcruise" },
];

export function resolveBrand(hostname) {
  for (const { pattern, brand } of domainPatterns) {
    if (pattern.test(hostname)) {
      return brands[brand];
    }
  }
  return brands[DEFAULT_BRAND];
}

export default brands;
